<template>
  <div :class="containerClass" class="text-xs md:text-sm lg:text-md">
    <svg class="stroke-current w-5 h-5 md:w-8 md:h-8 mr-1 md:mr-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.4 35.51"><g fill="none"><path d="M7.2,10.08a6.7,6.7,0,0,1,6.7,6.7h0V32.71A2.3,2.3,0,0,1,11.6,35H2.8a2.3,2.3,0,0,1-2.3-2.3h0V16.78a6.7,6.7,0,0,1,6.7-6.7Z"/><circle cx="7.2" cy="5.26" r="4.76"/><path d="M15.52,35H20.6a2.3,2.3,0,0,0,2.3-2.3h0V16.78a6.7,6.7,0,0,0-6.7-6.7h0a6.66,6.66,0,0,0-3.29.87"/><path d="M12.6,8.39a4.76,4.76,0,1,0,.47-6.72l-.24.23"/></g></svg>
    {{content}}
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true,
    },
    containerClass: {
      type: String,
      required: false,
    },
  },
};
</script>

<style>

</style>
